import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { useContext, useEffect } from 'react';
import { SiteConfigContext } from '../SiteConfigProvider';
import { isBrowser, useScript } from '@jelly/utils';

var QtWrapper = _styled("div", {
  target: "e17skuhf0",
  label: "QtWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "z3mxw0",
  styles: "margin:4rem 0;"
} : {
  name: "z3mxw0",
  styles: "margin:4rem 0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
/**
 * This component is for the QT Widget code
 * Will create a reference to load the qt widget
 *
 * @param {string} qtOfferGroupId Group id - 2 currently correlates to the "Small Businesses" group
 *
 */


export function QtWidget(_ref) {
  var _ref$qtOfferGroupId = _ref.qtOfferGroupId,
      qtOfferGroupId = _ref$qtOfferGroupId === void 0 ? '2' : _ref$qtOfferGroupId,
      _ref$qtViewType = _ref.qtViewType,
      qtViewType = _ref$qtViewType === void 0 ? 'default' : _ref$qtViewType;

  var _useScript = useScript('https://widgets.business.com/qt-widget-v2/bdcQtWidget.min.js'),
      _useScript2 = _slicedToArray(_useScript, 2),
      loaded = _useScript2[0],
      error = _useScript2[1];

  var _useContext = useContext(SiteConfigContext),
      _useContext$siteConst = _useContext.siteConstants,
      QT_ADMIN_PUB_ID = _useContext$siteConst.QT_ADMIN_PUB_ID,
      WIDGET_ENV = _useContext$siteConst.WIDGET_ENV;

  useEffect(function () {
    if (error) {
      return console.warn('Failed to load bdcQtWidget.min.js');
    }

    if (isBrowser() && loaded) {
      try {
        window.bdcQtWidget.init();
      } catch (error) {
        console.warn(error);
      }
    }
  }, [loaded, error]);
  return /*#__PURE__*/React.createElement(QtWrapper, null, /*#__PURE__*/React.createElement("div", {
    "data-bdc-qt-widget": true,
    "data-qt-pub-id": QT_ADMIN_PUB_ID,
    "data-qt-offer-group-id": qtOfferGroupId,
    "data-qt-stage": WIDGET_ENV,
    "data-qt-view-type": qtViewType
  }));
}